import React from "react";
import moment from "moment";
import {
  DatePicker as MuiDatePicker,
  TextField,
  IconButton
} from "material-ui";
import EventIcon from "material-ui/svg-icons/action/event";

const CONTAINER_STYLE = {
  position: "relative"
};

const CONTAINER_FULL_WIDTH_STYLE = {
  width: "100%"
};

const ICON_BUTTON_STYLE = {
  display: "inline-block",
  position: "absolute",
  right: -12,
  top: 0
};

const ICON_BUTTON_STYLE_WITH_LABEL = {
  display: "inline-block",
  position: "absolute",
  right: -12,
  top: 24
};

const DATE_PICKER_STLYE = {
  display: "none"
};

const localTimezone = moment.tz.guess();

class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      textFieldValue: "",
      value: null,
      datePickerOpen: false
    };

    this._parseTextDate = this._parseTextDate.bind(this);
    this._dateToText = this._dateToText.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onTextFieldBlur = this.onTextFieldBlur.bind(this);
    this.onTextFieldChange = this.onTextFieldChange.bind(this);
  }

  static defaultProps = {
    displayFormat: "MM/DD/YYYY",
    returnFormat: "YYYY-MM-DD"
  };

  _parseTextDate(text, format) {
    if (!text) {
      return null;
    }

    let m = moment.tz(text, format, localTimezone);
    return m.isValid() ? m : null;
  }

  _dateToText(date) {
    if (!date) {
      return "";
    }
    return moment.tz(date, localTimezone).format(this.props.displayFormat);
  }

  onChange(date) {
    let { returnFormat } = this.props,
      value = moment.tz(date, localTimezone);

    if (!date) {
      this.props.onChange(returnFormat ? "" : null);
    } else {
      this.props.onChange(returnFormat ? value.format(returnFormat) : value);
    }
  }

  onTextFieldBlur(e) {
    this.onChange(
      this._parseTextDate(e.target.value, this.props.displayFormat)
    );
  }

  onTextFieldChange(e) {
    this.setState({ textFieldValue: e.target.value });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {
    let { value, returnFormat } = props,
      dateValue =
        typeof value === "string"
          ? this._parseTextDate(value, returnFormat)
          : value;

    this.setState({
      textFieldValue: this._dateToText(dateValue),
      value: dateValue
    });
  }

  render() {
    let { name, style, label, fullWidth, minDate } = this.props,
      { value, textFieldValue, datePickerOpen } = this.state;

    return (
      <div
        style={Object.assign(
          {},
          CONTAINER_STYLE,
          fullWidth && CONTAINER_FULL_WIDTH_STYLE,
          style
        )}
      >
        <TextField
          name={name}
          fullWidth={true}
          value={textFieldValue}
          onChange={this.onTextFieldChange}
          onBlur={this.onTextFieldBlur}
          floatingLabelText={label}
        />
        <IconButton
          style={label ? ICON_BUTTON_STYLE_WITH_LABEL : ICON_BUTTON_STYLE}
          tooltip="Show calendar"
          onClick={() => {
            this.picker.openDialog();
          }}
        >
          <EventIcon />
        </IconButton>
        <MuiDatePicker
          ref={r => {
            this.picker = r;
          }}
          name={`${name}_datepicker`}
          style={DATE_PICKER_STLYE}
          dialogContainerStyle={{ zIndex: 9999999 }}
          value={value && new Date(value.year(), value.month(), value.date())}
          onChange={(e, date) => {
            this.onChange(date);
          }}
          autoOk={true}
          minDate={minDate}
        />
      </div>
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/app/components/partials/datepicker.jsx